import React from 'react'
import { Link } from 'react-router-dom'

import "../css/Notfound.css"

const NotFound = () => {
  return (
    <div className='NotfoundContainer'>
      <div className='notfoundmain'>
     <h1 className='notfounding'>404 Error - Page Not Found</h1>
         <div className='notfounddiv1'>
          This page or web address does not exit, Kindly go the home page via the button below
         </div>
         
         <div><Link to='/'><button >Home page</button></Link></div>

      </div>
    </div> 
  )
}

export default NotFound
